import { EUpdateModalTitle } from 'lib/storage';
import { connect } from 'react-redux';
import { IStoreState } from 'store';
import {
  setPostUpdateModalIsOpen,
  setAddNewUpdateModalIsOpen,
  setPostUpdateConfirmButtonPressed,
  postNewUpdate,
} from 'store/add-new-update/actions';
import { IPostUpdateState } from 'store/add-new-update/types';
import PostUpdateModal from './post-update-modal';

export interface IPostUpdateModalDispatchProps {
  setPostUpdateModalIsOpen: (isPostUpdateModalOpen: boolean) => void;
  setAddNewUpdateModalIsOpen: (isModalOpen: boolean, modalTitle: EUpdateModalTitle.NEW_UPDATE) => void;
  setPostUpdateConfirmButtonPressed: (isPostUpdateConfirmButtonPressed: boolean) => void;
  postNewUpdate: () => void;
}

export type TPostUpdateModalProps = IPostUpdateModalDispatchProps & IPostUpdateState;

const mapStateToProps = (state: IStoreState): IPostUpdateState => ({
  isPostUpdateModalOpen: state.addNewUpdate.isPostUpdateModalOpen,
  isModalOpen: state.addNewUpdate.isModalOpen,
  isPostUpdateConfirmButtonPressed: state.addNewUpdate.isPostUpdateConfirmButtonPressed,
  modalTitle: state.addNewUpdate.modalTitle,
});

const mapDispatchToProps = {
  setPostUpdateModalIsOpen,
  setAddNewUpdateModalIsOpen,
  setPostUpdateConfirmButtonPressed,
  postNewUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(PostUpdateModal);
